<template lang="html">
  <!-- <tr class="vcv-table-row"
      :class="{'selected': selected}"
  > -->
  <div>
    <template v-if="header.id === 'checkbox'">
      <vchecklabel v-model="selected" />
    </template>

    <template v-else-if="header.id === 'avatar'">
      <div
        class="column column-avatar column-link"
        :class="{ disabled: is_response_disabled }"
      >
        <router-link
          :to="path"
          class="response-link response-link__avatar"
          :disabled="is_response_disabled"
        >
          <div
            v-if="model.preview_link && visibility && !refusal"
            class="avatar-holder"
          >
            <img :src="model.preview_link" />
          </div>

          <div
            v-else-if="!hasVideo && visibility && !refusal"
            class="avatar-holder avatar-holder--audio"
          >
            <img src="/static/images/elements/equalizer.jpg" />
          </div>

          <div v-else-if="!visibility || refusal" class="avatar-empty">
            <img src="/static/images/elements/hide-avatar.png" />
          </div>

          <div v-else class="avatar-empty">
            <img src="/static/images/elements/empty-avatar.png" />
          </div>

          <!-- schlum -->
          <div
            :class="[
              'candidate-name',
              { 'candidate-name__hide': !visibility || refusal }
            ]"
          >
            <span>{{ fullNameToDisplay }}</span>
          </div>
        </router-link>
      </div>
    </template>

    <template v-else-if="header.id === 'vacancy'">
      <div
        class="column column-vacancy column-link"
        :class="{ disabled: is_response_disabled }"
      >
        <router-link
          :to="path"
          :disabled="is_response_disabled"
          class="response-link"
        >
          <div
            :class="[
              'candidate-position',
              { 'candidate-position__hide': !visibility || refusal }
            ]"
          >
            <span :title="vacancy.name"> {{ vacancy.name }} </span>

            <span
              v-if="!vacancy.is_active && !vacancy.is_deleted"
              class="archive-label"
            >
              {{ $tr('vacancies.archiveLabel') }}
            </span>

            <span class="remove-label" v-if="vacancy.is_deleted">
              {{ $tr('vacancies.removeLabel') }}
            </span>
          </div>
        </router-link>
      </div>
    </template>

    <template v-else-if="header.id === 'status'">
      <div :class="{ disabled: is_response_disabled }">
        <div
          v-if="status"
          v-on-click-away="hideStatusesDropdown"
          :class="[
            'candidate-info-item',
            {
              'candidate-info-unpaid': not_paid
            }
          ]"
        >
          <div class="cell-block cell-block__status">
            <div
              class="cell-statuses_label"
              @click="changeStatusesDropdownVisible(!isStatusesDropdownVisible)"
            >
              {{ status }}
              <div
                class="cell-statuses_icon"
                :class="{ 'is-active': isStatusesDropdownVisible }"
              >
                <img src="/static/icons/responses-list-dropdown.svg" />
              </div>
            </div>

            <transition name="fade">
              <div
                v-if="isStatusesDropdownVisible"
                :class="{ loading: loadingStatus }"
                class="cell-statuses_dropdown"
              >
                <ul class="cell-statuses_list">
                  <li
                    v-for="item in statusesFilteredByRole"
                    class="cell-statuses_item"
                    :key="item.id"
                    @click="statusChange(item)"
                  >
                    {{ item.name }}
                  </li>
                </ul>
              </div>
            </transition>
          </div>

          <span v-if="model.is_hidden" class="remove-label">
            {{ $tr('response.hiddenByCandidate') }}
          </span>
        </div>
      </div>
    </template>

    <template v-else-if="header.id === 'ratings'">
      <div
        class="column column-rating column-link"
        :class="{ disabled: is_response_disabled }"
      >
        <router-link
          :to="path"
          :disabled="is_response_disabled"
          class="response-link"
        >
          <div class="stars">
            <span v-for="i in stars" class="star green">
              <i class="fa fa-star"></i>
            </span>
            <span v-for="i in stars_unselected" class="star gray">
              <i class="fa fa-star"></i>
            </span>
          </div>
        </router-link>
      </div>
    </template>
    <template v-else-if="header.id === 'date'">
      <div
        class="column column-date column-link"
        :class="{ disabled: is_response_disabled }"
      >
        <router-link
          :to="path"
          class="response-link"
          :disabled="is_response_disabled"
        >
          <div>{{ created_at_time }}</div>
          <div>{{ created_at }}</div>
        </router-link>
      </div>
    </template>
    <template v-else-if="header.id === 'date_sent'">
      <div
        class="column column-date column-link"
        :class="{ disabled: is_response_disabled }"
      >
        <router-link
          :to="path"
          :disabled="is_response_disabled"
          class="response-link"
        >
          <div>{{ date_sent_time }}</div>
          <div>{{ date_sent }}</div>
        </router-link>
      </div>
    </template>

    <template v-else-if="header.id === 'source'">
      <div
        class="column column-source column-link"
        :class="{ disabled: is_response_disabled }"
      >
        <router-link
          :to="path"
          class="response-link"
          :disabled="is_response_disabled"
        >
          <div>{{ model.source.name }}</div>
        </router-link>
      </div>
    </template>

    <template v-else-if="header.id === 'creator'">
      <div :class="{ disabled: is_response_disabled }">
        {{ vacancyCreator }}
      </div>
    </template>

    <template v-else-if="header.id === 'resume'">
      <div
        class="column column-resume column-link"
        :class="{ disabled: is_response_disabled }"
      >
        <div class="cv-row">
          <a
            v-if="model.resume_url"
            :href="model.resume_url"
            class="cv-row-resume-link"
            target="_blank"
            rel="noopener"
            v-tooltip="{
              content: model.resume_url,
              placement: 'top-center',
              classes: 'cv-tooltip'
            }"
          >
            <svg class="cv-row-icon">
              <use xlink:href="/static/icons/cv-icons.svg#file"></use>
            </svg>
          </a>
          <a
            class="cv-row-resume-link"
            v-if="model.second_resume_url"
            :href="model.second_resume_url"
            target="_blank"
            rel="noopener"
            v-tooltip="{
              content: model.second_resume_url,
              placement: 'top-center',
              classes: 'cv-tooltip'
            }"
          >
            <svg class="cv-row-icon">
              <use xlink:href="/static/icons/cv-icons.svg#url"></use>
            </svg>
          </a>
        </div>
      </div>
    </template>

    <template v-else-if="header.id === 'comments'">
      <div
        class="column column-comments"
        :disabled="is_response_disabled"
        :class="{ disabled: is_response_disabled }"
      >
        <div
          v-if="lastCommentMessage && !commentMode"
          class="comment-box"
          @click="editLastComment"
        >
          <span v-html="linkify(lastCommentMessage)"></span>
        </div>

        <textarea
          v-else
          type="text"
          ref="commentInput"
          v-model="comment"
          :class="[
            'comment-text',
            {
              'comment-text-empty': !comment.length && !is_focused
            }
          ]"
          :placeholder="
            clippedLastCommentMessage || $tr('responses.leaveComment')
          "
          @blur.prevent="leaveComment"
          @focus.prevent="focus_textarea"
          @keypress="commentKeyPress"
        />
      </div>
    </template>

    <template v-else>
      <div>{{ cell[header.id] || '' }}</div>
    </template>
  </div>
</template>

<script>
// import Moment from 'moment'
// import Vue from 'vue'
import IEBrowserDetector from '@/components/mixin/IEBrowserDetector';
import { ResponsesRowMixin } from '@/components/responses/tablerow/rowMixin';
import { linkify } from '@/_helpers/utils';
import { directive as onClickaway } from 'vue-clickaway';

// import { mapMutations } from 'vuex'

// const COMMENT_MAX_LENGTH = 30

export default {
  name: 'schlum-responses-row',

  mixins: [IEBrowserDetector, ResponsesRowMixin],

  directives: {
    onClickaway
  },

  props: {
    model: Object,
    header: Object,
    cell: Object,
    fullName: {
      type: String,
      default: ''
    },
    statuses: Array,
    loadingStatus: Boolean
  },

  data() {
    return {
      isStatusesDropdownVisible: false
    };
  },

  methods: {
    linkify(inputText) {
      return linkify(inputText);
    },

    async statusChange(item) {
      this.$emit('statusChange', {
        status: item,
        response: this.model
      });
    },

    changeStatusesDropdownVisible(val) {
      this.isStatusesDropdownVisible = val;
    },

    hideStatusesDropdown(val) {
      this.isStatusesDropdownVisible = false;
    }
    // allowSelect () {
    //   const isSelectionMode = getSelection().toString().length > 0
    //
    //   if (!isSelectionMode) {
    //     this.routeToCard()
    //   }
    // },
    //
    // routeToCard () {
    //   if (this.showRoute) {
    //     this.$router.push(this.showRoute)
    //   }
    // },
    //
    // updateComments (comments) {
    //   // Разворачиваем комментарии, т.к. при показе в таблице
    //   // должен отображаться последний по дате комментарий
    //   const reverseComments = [ ...comments ].reverse()
    //
    //   this.updateCommentsForResponse({
    //     responseId: this.model.id,
    //     comments: reverseComments
    //   })
    // },
    //
    // leaveComment (event) {
    //   const message = event.target.value
    //
    //   if (message === this.lastCommentMessage) {
    //     this.commentMode = false
    //     return
    //   }
    //
    //   if (message.length > 0) {
    //     const lastCommentOnBack = this.model.comments.length > 0 ? this.model.comments[0] : null
    //
    //     if (lastCommentOnBack) {
    //       this.$store
    //         .dispatch('response/updateComment', {
    //           responseId: this.model.id,
    //           commentId: lastCommentOnBack.id,
    //           message: event.target.value
    //         })
    //         .then(comments => this.updateComments(comments))
    //     } else {
    //       this.$store
    //         .dispatch('response/createComment', {
    //           id: this.model.id,
    //           message: event.target.value
    //         })
    //         .then(comments => this.updateComments(comments))
    //     }
    //   }
    //   this.commentMode = false
    // },
    //
    // commentKeyPress (event) {
    //   if (event.code === 'Enter') {
    //     // to prevent double comment add, use blur instead of direct method leaveComment call
    //     this.$refs.commentInput.blur()
    //   }
    // },
    //
    // editLastComment () {
    //   if (this.lastCommentMessage) {
    //     this.comment = this.lastCommentMessage
    //   }
    //
    //   this.commentMode = true
    //   Vue.nextTick(() => {
    //     this.$refs.commentInput.focus()
    //   })
    // },
    //
    // ...mapMutations({
    //   updateCommentsForResponse: 'responses/updateCommentsForResponse'
    // })
  },

  computed: {
    // showRoute () {
    //   return {
    //     path: `/responses/${this.model.id}`
    //   }
    // },

    // is_japan_locale() {
    //   return this.$store.getters['locale/is_japan_locale'];
    // },
    //
    // dateFormat() {
    //   return this.is_japan_locale ? 'YYYY.MM.DD' : 'DD.MM.YYYY';
    // },
    //
    // selected: {
    //   get () {
    //     return this.$store.getters['responses/isSelected'](this.model)
    //   },
    //
    //   set (val) {
    //     this.$store.commit('responses/select', {
    //       model: this.model,
    //       value: val
    //     })
    //   }
    // },
    //
    // status () {
    //   return this.model.status.name
    // },
    //
    // candidate () {
    //   return this.model.candidate
    // },
    //
    // vacancy () {
    //   return this.model.vacancy
    // },
    //
    // source () {
    //   return this.model.source
    // },
    //
    // stars () {
    //   return this.model.star ? this.model.star.value : 0
    // },
    //
    // createdAtDate () {
    //   return this.model.created_at
    //     ? Moment(this.model.created_at).format(this.dateFormat)
    //     : null
    // },
    //
    // createdAtTime () {
    //   return this.model.created_at
    //     ? Moment(this.model.created_at).format('HH:mm')
    //     : null
    // },
    //
    // lastCommentMessage () {
    //   return this.model.comments.length > 0 ? this.model.comments[0].message : null
    // },
    //
    // clippedLastCommentMessage () {
    //   const comment = this.lastCommentMessage
    //
    //   if (comment) {
    //     return comment.length > COMMENT_MAX_LENGTH
    //       ? comment.slice(0, COMMENT_MAX_LENGTH) + '...'
    //       : comment
    //   }
    //
    //   return null
    // },
    //
    // isNew () {
    //   return parseInt(this.model.status.id) === 1
    // },
    //
    // full name from props or default value
    fullNameToDisplay() {
      return (
        this.fullName || [this.candidate.name, this.candidate.surname].join(' ')
      );
    },
    //
    // responseSpecialProcess() {
    //   return this.model.special_process
    // },
    //
    // isInternalCandidate () {
    //   return this.responseSpecialProcess ? this.responseSpecialProcess.is_internal : null
    // }
    statusesFilteredByRole() {
      return this.statuses
        .filter(i => (this.isRoleRead ? !i.is_base : true))
        .filter(i =>
          this.model && this.model.status ? this.model.status.id !== i.id : true
        );
    },

    isRoleRead() {
      if (!this.model || !this.model.vacancy) {
        return false;
      }

      return this.model.vacancy.role === 'role_read';
    }
  },

  beforeDestroy() {
    this.emailTemplate = {};
  }
};
</script>

<style lang="scss" scoped>
  @import '@/styles/colors.scss';
  @import '@/styles/variables.scss';
  @import '@/styles/components/responses/RowContent.scss';

  .candidate-name {
    display: flex;
    align-items: center;

    .new-label {
      font-size: 11px;
      background: $green;
      padding: 3px 9px;
      border-radius: 4px;
      height: auto;
      line-height: 1.25;
      text-transform: capitalize;
      bottom: 7px;

      span {
        background: transparent;
      }
    }
  }

  .mb-10 {
    margin-bottom: 10px;
  }

  .column-university {
    font-size: 14px;
  }

  .cv-row {
    display: flex;
    align-items: center;
  }
  .cv-icon {
    width: 24px;
    height: 24px;
  }
  .resume-link {
    color: #9faab6;

    &:hover,
    &:focus,
    &:active {
      color: #d1d8e0;
      transition: color ease-in-out 0.3s;
    }

    &:not(:last-child) {
      margin-right: 6px;
    }
  }

  .comment-box {
    ::v-deep a {
      cursor: pointer !important;
    }
  }

  .remove-label {
    padding: 3px;
    margin: 0;
    position: static;
    font-size: 10px;
    display: inline;
  }

  .cell-block {
    display: block;
  }

  .column-avatar {
    display: flex;
    align-items: center;
  }

  .response-link__avatar {
    width: auto;
    min-width: 84px;
    margin-right: 16px;
  }

  .cell-statuses_icon {
    display: flex;
    align-items: center;
    transform: rotate(180deg);
    transition: all linear 0.4s;
    opacity: 0;
    visibility: hidden;

    &.is-active {
      transform: rotate(0);
    }
  }

  .cell-block__status {
    position: relative;

    &:hover {
      .cell-statuses_icon {
        opacity: 1;
        visibility: visible;
      }
    }
  }

  .cell-statuses_label {
    display: flex;
    align-items: center;
    cursor: pointer;
    font-weight: 700;
  }

  .cell-statuses_list {
    padding: 0;
    list-style: none;
  }

  .cell-statuses_item {
    cursor: pointer;
    transition: all linear 0.4s;

    &:not(:last-child) {
      margin-bottom: 0.5rem;
    }

    &:hover {
      color: $green-hover;
    }
  }

  .cell-statuses_dropdown {
    position: relative;
    padding: 12px;
    border: 1px solid #d1d8e0;
    box-sizing: border-box;
    border-radius: 2px;
    position: absolute;
    top: calc(100% + 4px);
    left: -18px;
    min-width: 155px;
    background: #fff;
    z-index: 2;

    &.loading {
      &:after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0.7;
        background: #fff;
        cursor: wait;
      }
    }
  }
</style>
